import { Component } from 'react'

export default class Account extends Component {
	render() {
		return <div className="page-content">Account</div>
	}
}
